import React, { Component } from "react";
import { Button, Row, Col, Tabs, Input, Popover, Empty, } from "antd";
import * as icons from "@ant-design/icons";

import "./index.less";

const { CloseOutlined } = icons;

const antDIcons = Object.keys(icons)
  .filter(key => key.includes("Outlined")).map(key => {
    return {
      value: key,
      component: icons[key],
    };
  });

export default class IconPicker extends Component {

  state = {
    open: false,
  };

  getSelectIconComp = () => {
    const { value } = this.props
    if (!value || !icons[value]) {
      return "无";
    }
    const Icon = icons[value];
    return <Icon />;
  };

  onOpenChange = (open) => {
    this.setState({ ...this.state, open, });
  };

  onIcon = (e) => {
    const { value } = e;
    this.setState({
      ...this.state,
      open: false,
    }, () => {
      this.props.onChange && this.props.onChange(value);
    });
  };

  onClear = () => {
    this.setState({
      ...this.state,
      open: false,
    }, () => {
      this.props.onChange && this.props.onChange();
    });
  };

  render() {
    const { open } = this.state;
    const items = [
      {
        label: "内置",
        key: "1",
        children: (
          <div className="icon-picker-icons">
            <Row justify="center" gutter={[8, 8]}>
              {
                antDIcons.map(item => {
                  const { value, component: Icon } = item;
                  return (
                    <Col key={value} span={4}>
                      <Button icon={<Icon />} onClick={this.onIcon.bind(this, item)} />
                    </Col>
                  )
                })
              }
            </Row>
          </div>
        ),
      },
      {
        label: "自定义",
        key: "2",
        children: (
          <div className="icon-picker-icons">
            <Row justify="center" gutter={[8, 8]}>
              <Empty />
            </Row>
          </div>
        ),
      },
    ];
    return (
      <div className="icon-picker">
        <Popover
          trigger="click"
          open={open}
          placement="bottom"
          onOpenChange={this.onOpenChange}
          content={
            <div className="icon-picker-box">
              <Tabs
                size="small"
                items={items}
                defaultActiveKey="1"
              />
            </div>
          }
        >
          <div className="icon-picker-input">
            <Input
              placeholder="搜索图标"
              addonBefore={this.getSelectIconComp()}
              addonAfter={<CloseOutlined onClick={this.onClear} />}
            />
          </div>
        </Popover>
      </div>
    );
  };
};
